import React from "react";
import Reveal from "@/components/Reveal";

const steps = [
 { n: "01", t: "Understand the right structure", d: "PVT. LTD., LLP, OPC mapped to your goals." },
 { n: "02", t: "Complete legal setup", d: "Registration, PAN, TAN, GST, MSME." },
 { n: "03", t: "Build online presence", d: "Domain, workspace email, launch website." },
 { n: "04", t: "Prepare launch essentials", d: "Bank account, invoicing, contracts." },
 { n: "05", t: "Stay compliant and grow", d: "ROC, ITR, advisory we're your compliance partner." },
];

export const StartupJourney = () => (
 <section className="bg-white border-t border-[#EAEAEA]" data-testid="startup-journey">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
 <Reveal>
 <div className="max-w-2xl">
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 Startup Journey
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
 Your journey doesn't end with{" "}
 <span className="hl-yellow">registration</span>.
 </h2>
 <p className="mt-5 text-[16px] md:text-[17px] text-[#1C1F26] leading-relaxed">
 A First-Time Founder needs a partner across five clear stages not
 just a filing agent for one.
 </p>
 </div>
 </Reveal>

 <div className="mt-14 relative">
 <div className="hidden md:block absolute left-0 right-0 top-9 h-[2px] bg-[#EAEAEA]" aria-hidden />
 <div className="hidden md:block absolute left-0 top-9 h-[2px] bg-[#FDD805]" style={{ width: "80%" }} aria-hidden />

 <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4">
 {steps.map((s, i) => (
 <Reveal key={s.n} delay={i * 100}>
 <div className="relative flex flex-col items-center text-center">
 <div className="w-[72px] h-[72px] rounded-full bg-white border-2 border-[#0F1115] flex items-center justify-center font-display font-black text-[22px] text-[#0F1115] relative z-10">
 {s.n}
 </div>
 <h3 className="mt-5 font-display font-bold text-[17px] text-[#0F1115]">
 {s.t}
 </h3>
 <p className="mt-1.5 text-[14px] text-[#4A4A4A] leading-relaxed">
 {s.d}
 </p>
 </div>
 </Reveal>
 ))}
 </div>
 </div>
 </div>
 </section>
);

export default StartupJourney;
